import React, { useState, useEffect, useContext  } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/auth';
import { useNavigate , useParams } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';

import { formatDate, isDate, parse } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';

import Globais from '../../components/Globais/Globais'; 
import { dataHoraFormatoMySQL, converterDataBrasileiraParaMySQL } from './../../services/datautils.js'
import { getS3Url } from '../../services/funcoes';
// import { localizarOrdem, atualizarOrdem } from '../../services/api';
import { buscarOrdem, incluirOrdem, listarAnalises, listarEquipamentos, listarDesvios, alterarOrdem, excluirOrdem, gerarRelatorio } from '../../services/apigateway.js';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer';

import ProcessandoModal from '../../components/Processamento/processamento.js';

import AnaliseCard from '../../components/Analises/analises';
import DocumentoCard from '../../components/DocumentoAprovacao/documentoaprovacao'

import { FaCircleXmark } from 'react-icons/fa6';
import { CgAdd } from "react-icons/cg";
import { TbPhotoSearch } from 'react-icons/tb';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';

import ModalSenha from '../../components/Modal/modalsenha';
import ModalImagem from '../../components/Modal/modalimagem';

import Axios from 'axios';

export default function CadastroOrdem({ funcao }) {
  const { clienteId, identificador, ligaMenu, perfilUsuario } = useContext(AuthContext);
  const { ordemId } = useParams();
  const readOnly = (funcao === 'Consulta' || funcao === 'Exclusão');
  const [loading, setLoading] = useState(false);
  const [printing, setPrinting] = useState(false);

  const [refreshToken, setRefreshToken] = useState(Date.now());

  const history = useNavigate();
  // const location = useLocation();

  const[ordem, setOrdem] = useState([]);

  const[numero, setNumero] = useState('');
  const[dataInclusao, setDataInclusao] = useState('');
  const[responsavel, setResponsavel] = useState('');
  const[equipamentoId, setEquipamentoId] = useState('');
  const[nomeEquipamento, setNomeEquipamento] = useState('');
  const[horas, setHoras] = useState('');
  const[dataInicial, setDataInicial] = useState('');
  const[dataFinal, setDataFinal] = useState('');
  const[observacao, setObservacao] = useState('');
  const[desvioId, setDesvioId] = useState('');
  const[descricaoDesvio, setDescricaoDesvio] = useState('');
  const[idtFotoDesvio, setIdtFotoDesvio] = useState('');
  const[fotoDesvio, setFotoDesvio] = useState('');
  const[idtDocAprovacao, setIdtDocAprovacao] = useState('');
  const[documentoAprovacao, setDocumentoAprovacao] = useState('');
  const[basculado, setBasculado] = useState('');
  const[situacao, setSituacao] = useState('A');

  const [analises, setAnalises] = useState([]);

  const [equipamentos, setEquipamentos] = useState([]);
  const [equipamentoSelected, setEquipamentoSelected] = useState(null);

  const [desvios, setDesvios] = useState([]);
  const [desvioSelected, setDesvioSelected] = useState(null);

  const [mostrarModalSenha, setMostrarModalSenha] = useState(false);
  const [mostrarModalImagem, setMostrarModalImagem] = useState(false);
  const [preview, setPreview] = useState(null);

  const [dateAux, setDateAux] = useState(new Date());

  useEffect(() => {
    // Buscar dados da OM e análises
    async function carregarDados() {
      try {
        const response = await buscarOrdem(clienteId, ordemId);
        preencheSelecionado(response[0]);      

      } catch (err) {
        toast.error('Erro ao buscar ordem', err);
      }
    }

    if ((funcao === 'Alteração' || funcao === 'Exclusão') && perfilUsuario === 'US') { setMostrarModalSenha(true); }
    
    if (funcao !== 'Inclusão') { 
      setLoading(true);
      carregarDados() 
      setLoading(false);
    } 
    
    if (funcao === 'Inclusão' || funcao === 'Alteração') {
      setLoading(true);
      loadEquipamentos();
      loadDesvios();
      setLoading(false);
    }

  }, [funcao]);

  function preencheSelecionado(response) {
    setOrdem(response);

    setNumero(response.num_ordmanutencao);
    setDataInclusao(response.dat_horinclusao);
    setResponsavel(response.res_ordmanutencao);
    setEquipamentoId(response.cod_equipamento);
    setNomeEquipamento(response.mod_equipamento + ' - ' + response.tag_equipamento);
    setHoras(response.hor_manutencao);
    setDataInicial(response.dat_horinicial);
    setDataFinal(response.dat_horfinal);
    setObservacao(response.obs_ordmanutencao);
    setDesvioId(response.cod_desvio);
    setDescricaoDesvio(response.des_desvio);
    setIdtFotoDesvio(response.idt_fotdesvio);
    setIdtDocAprovacao(response.idt_docaprovacao);
    setBasculado(response.idt_basequipamento);
    setSituacao(response.sit_ordmanutencao);

    if (funcao === 'Consulta' || funcao === 'Exclusão') { carregaAnalises(response.cod_equipamento);}

    if (funcao = 'Alteração') {
      const dataConvertida = parse(response.dat_horinclusao, 'dd/MM/yyyy HH:mm', new Date());
      setDateAux(dataConvertida);

      if (response.idt_fotdesvio && response.idt_fotdesvio.trim() !== '') setPreview(getS3Url(response.idt_fotdesvio) + `?t=${Date.now()}`);
    }
  }

  async function carregaAnalises(equipamentoId) {
    try {
      const response = await listarAnalises(clienteId, ordemId, equipamentoId);
      setAnalises(response);

    } catch (err) {
      toast.error('Erro ao buscar análise');
    }  
  }

  async function loadEquipamentos() {
    try {
      const response = await listarEquipamentos(clienteId);
      setEquipamentos(response);

    } catch(err) {
      console.log(err);
    }
  }

  function handleChangeEquipamento(valor){
    if (valor) { 
      setEquipamentoSelected(valor);
      setEquipamentoId(equipamentos[valor].cod_equipamento);
      setNomeEquipamento(`${equipamentos[valor].tag_equipamento} - ${equipamentos[valor].mod_equipamento}`)
    }
  } 

  async function loadDesvios() {
    try {
      const result = await listarDesvios(clienteId);
      setDesvios(result);

    } catch (err) {
      toast.error('Erro ao buscar desvios');
    }  
  }

  function handleChangeDesvio(valor){
    if (valor) { 
      setDesvioSelected(valor);
      setDesvioId(desvios[valor].cod_desvio);
      setDescricaoDesvio(`${desvios[valor].des_desvio}`)
    }
  } 

  async function executaAcao(e){
    e.preventDefault();

    if (funcao === 'Consulta') {
      history('/ordens');
    }

    if (funcao === 'Alteração' || funcao === 'Inclusão') {
      if (numero === '' || responsavel === '' || dateAux === '' || situacao === '' || equipamentoId === '') {
        toast.error('Informe todos os campos obrigatórios');
        return;
      }
      if (!isDate(dateAux)) {
        toast.error('Informe uma data de inclusão válida!');
        return;
      }
    }

    if (funcao === 'Inclusão') {
      //INSERT
      try {
        const response = await incluirOrdem({
          clienteId: clienteId,
          numero: numero, 
          dataInclusao: dataHoraFormatoMySQL(dateAux), 
          responsavel: responsavel, 
          equipamentoId: equipamentoId, 
          horas: horas, 
          dataInicial: dataHoraFormatoMySQL(dateAux), 
          dataFinal: dataHoraFormatoMySQL(dateAux), 
          observacao: observacao, 
          desvioId: desvioId, 
          fotoDesvio: fotoDesvio, 
          basculado: basculado, 
          situacao: situacao,
        });
      
        if (response.codigo === '000') {
          toast.success(response.mensagem);
          history(`/ordens/consulta/${response.corpo}`);
        
        } else {
          toast.error(`Erro ao incluir ordem: ${response.mensagem}`);
        }

      } catch (err) {
        console.log("Erro na Inclusão de Ordem: ", err);
        toast.error(`Erro ao buscar ordem: ${err}`);
      }  
    }

    if (funcao === 'Alteração') {
      try {
        const response = await alterarOrdem( 
          {
            clienteId: clienteId,
            ordemId: ordemId,
            numero: numero, 
            dataInclusao: dataHoraFormatoMySQL(dateAux), 
            responsavel: responsavel, 
            equipamentoId: equipamentoId, 
            horas: horas, 
            observacao: observacao, 
            desvioId: desvioId, 
            idtFotoDesvio: idtFotoDesvio,
            fotoDesvio: fotoDesvio, 
            idtDocAprovacao: idtDocAprovacao,
            documentoAprovacao: documentoAprovacao,
            basculado: basculado, 
            situacao: situacao,
          }
        );
      
        if (response.codigo === '000') {
          toast.success(response.mensagem);
          history(`/ordens/consulta/${response.corpo}`, { state: { atualizado: true } });
        
        } else {
          toast.error(`Erro ao atualizar ordem: ${response.mensagem}`);
        }

      } catch (err) {
        toast.error(`Erro ao atualizar ordem: ${err}`);
      }  
    }

    if (funcao === 'Exclusão') {
      //DELETE
      try {
        const response = await excluirOrdem(clienteId, ordemId, numero, idtFotoDesvio, idtFotoDesvio, idtDocAprovacao);
      
        if (response.codigo === '000') {
          toast.success('Ordem excluída com sucesso!!');
          history('/ordens');
        
        } else {
          let mensagem = '';

          if (response.retorno === 'ER_ROW_IS_REFERENCED_2') {
            mensagem = 'Ordem não pode ser excluída. As análises efetuadas devem ser excluídas antes!!'

          } else {
            mensagem = `Erro ao excluir ordem: ${response.mensagem}`
          }
          toast.error(mensagem);
        }
      } catch (err) {
        toast.error('Erro ao excluir ordem');
      }  
    }

    return;
  }

  async function imprimirOrdem(e) {
    e.preventDefault();

    const parametros = { 
      relatorio: 'ordem',
      codigoRelatorio: 'FMQ-SGQ-19',
      clienteId: clienteId,
      ordemId: Number(ordemId),
    };

    try {
      setPrinting(true);

      console.log('parametros: ', parametros);

      const campos = {};
      const response = await gerarRelatorio(parametros, campos);
      // console.log("response em relatorios.js: ", response);
      
      if (response.data.statusCode === 200) {
        const { downloadUrl } = JSON.parse(response.data.body);

        // console.log('download url:', downloadUrl);

        // Abrir em nova aba
        window.open(downloadUrl, "_blank");

        // // Ou forçar download automático
        // const link = document.createElement("a");
        // link.href = downloadUrl;
        // link.download = "relatorio.pdf"; // nome sugerido
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);

      } else {
        toast.error(JSON.parse(response.data.body));
      }

    } catch (err) {
      toast.error('Erro ao gerar Relatório');
    }  

    setPrinting(false);
  }

  function handleSair(e){
   history('/ordens');
  }

  function incluirAnalise() {
    // console.log('Datas OM em IncluirAnalise: ', dataInicial, dataFinal);

    let datainicialOM = converterDataBrasileiraParaMySQL(dataInicial, 'aaaa-mm-dd HH:MM');
    let datafinalOM = converterDataBrasileiraParaMySQL(dataFinal, 'aaaa-mm-dd HH:MM');

    // console.log('Datas da OM em incluirAnalise: ', datainicialOM, datafinalOM);

    history(`/analises/inclusao/${numero}/${ordemId}/${nomeEquipamento}/${equipamentoId}/${datainicialOM}/${datafinalOM}`);
  }

  function editarAnalise(compartimentoId) {
    // console.log('Datas OM em editarAnalise: ', dataInicial, dataFinal);

    let datainicialOM = converterDataBrasileiraParaMySQL(dataInicial);
    let datafinalOM = converterDataBrasileiraParaMySQL(dataFinal);

    // console.log('Datas OM formatadas em editarAnalise: ', datainicialOM, datafinalOM);

    history(`/analises/alteracao/${numero}/${ordemId}/${nomeEquipamento}/${equipamentoId}/${compartimentoId}/${datainicialOM}/${datafinalOM}`);
  }

  function excluirAnalise(compartimentoId) {
    // console.log('Datas OM em editarAnalise: ', dataInicial, dataFinal);

    let datainicialOM = converterDataBrasileiraParaMySQL(dataInicial);
    let datafinalOM = converterDataBrasileiraParaMySQL(dataFinal);
    let datainclusaoOM = converterDataBrasileiraParaMySQL(dataInclusao);

    // console.log('Datas da OM em excluirAnalise: ', datainicialOM, datafinalOM);

    history(`/analises/exclusao/${numero}/${ordemId}/${nomeEquipamento}/${equipamentoId}/${compartimentoId}/${datainicialOM}/${datafinalOM}/${datainclusaoOM}`);
  }

  function incluirAprovacao(tipo) {
    // console.log('Tipo de Aprovação: ', tipo);

    if (tipo === 'Inclusão') { history(`/docaprovacao/inclusao/${numero}/${ordemId}/${nomeEquipamento}/${equipamentoId}`); return;}
    if (tipo === 'Alteração') { history(`/docaprovacao/alteracao/${numero}/${ordemId}/${nomeEquipamento}/${equipamentoId}/${idtDocAprovacao}`); return;}
    if (tipo === 'Exclusão') { history(`/docaprovacao/exclusao/${numero}/${ordemId}/${nomeEquipamento}/${equipamentoId}/${idtDocAprovacao}`); return;}
    // if (tipo = 'Consulta') { history(`/docaprovacao/consulta/${numero}/${ordemId}/${nomeEquipamento}/${equipamentoId}/${idtDocAprovacao}`); return;}
  }

  if (mostrarModalSenha) {
    return(
      <>
        {<ModalSenha identificador={identificador} onConfirmar={() => autorizado()} onCancelar={() => naoAutorizado()} />}
      </>
    )
  }

  function autorizado() {
    setMostrarModalSenha(false);
  }

  function naoAutorizado() {
    setMostrarModalSenha(false);
    history('/ordens');
  }

  function selecionarImagem(file) {
    setFotoDesvio(file);
    setPreview(URL.createObjectURL(file));
  }

  function limpaArquivo() {
    setPreview(null);
    setFotoDesvio('');
  }

  function limpaDesvio() {
    setDesvioSelected('');
    setDesvioId(null);
    setDescricaoDesvio(null);
    setDesvioId(0);
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Ordem de Manutenção'} />

        <section className='md:grid md:grid-cols-[minmax(175px,20%)_minmax(60%,80%)] grid-cols-1'>
          <Menu />
          <div className=''>
          <span>Buscando Ordem de Manutenção...</span>
        </div>
        </section>
      </main>
    </div>
    )
  }

  if (printing){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Ordem de Manutenção'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={printing} message="Aguarde, imprimindo Ordem de Manutenção..." />
        </section>
      </main>
    </div>
    )
  }


  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />

      <main>
        <Titulo tela={'Cadastro de Ordem de Manutenção' + ' - ' + `${funcao}`} destination={''} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <section className='p-4 h-full'>
            <h3 className="text-xl font-semibold text-gray-700">Informações da Ordem de Manutenção</h3>
            {/* <h3 className='font-semibold text-lg mb-3 mt-1'>Informações da Ordem de Manutenção</h3> */}

            <div>
              {/* Dados da OM */}
              <div className="space-y-2">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="input-group md:mb-3">
                    <label>Número</label>
                    <input 
                      name='numero' 
                      placeholder={'Digite o número da ordem de manutenção'}
                      className='w-full p-2 border border-gray-300 rounded-md mb-2' 
                      value={numero} 
                      onChange={(e) => setNumero(e.target.value)}
                      readOnly={readOnly}
                    />
                  </div>
                  <div className="input-group md:mb-3">
                    <label>Data Inclusão</label>

                    {(funcao === 'Inclusão' || funcao === 'Alteração') ? (
                      <div>
                        <DatePicker
                          selected={dateAux}
                          onChange={(date) => setDateAux(date)}
                          dateFormat="dd/MM/yyyy HH:mm"
                          locale="pt-BR"
                          placeholderText="Selecione"
                          className="w-full p-2 border border-gray-300 rounded-md"
                          isClearable
                          showTimeSelect
                          timeIntervals={1}
                        />
                      </div>
                    ) : (
                      <div>
                        <input 
                          type="text" 
                          id='datainclusao' 
                          name='inclusao' 
                          placeholder={'Data Inclusão'}
                          className='w-full p-2 border border-gray-300 rounded-md' 
                          autoComplete='Inclusão' 
                          value={dataInclusao} 
                          onChange={(e) => setDataInclusao(e.target.value)}
                          readOnly={readOnly}
                        />
                      </div>                    
                    )}
                  </div>
                </div>
                <div>
                  <div className="input-group md:mb-3">
                    <label>Responsável</label>
                    <input 
                      type="text" 
                      id='responsavel' 
                      name='responsavel' 
                      placeholder={'Digite o Responsável'}
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      autoComplete='responsavel' 
                      value={responsavel} 
                      onChange={(e) => setResponsavel(e.target.value)}
                      readOnly={readOnly}
                    />
                  </div>
                </div>
                <div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="input-group md:mb-3">
                      <label>Equipamento</label>

                      {(funcao === 'Inclusão' || funcao === 'Alteração') ? (
                        <div className="single-input">
                          <span>
                            <select className="combo-select" value={equipamentoSelected} onChange={e => handleChangeEquipamento(e.target.value)} >
                              {(funcao === 'Inclusão') ? (
                                <option key='0' value=''>Selecione um Equipamento</option>
                              ):(
                                <option key={equipamentoId} value={equipamentoSelected}>{nomeEquipamento}</option>
                              )}
                              {equipamentos.map((item, index) => {
                                return(
                                  <option key={item.cod_equipamento} value={index}>
                                    {`${item.tag_equipamento} - ${item.mod_equipamento}` }
                                  </option>
                                )
                              })}
                            </select>
                          </span>
                        </div>
                      ):(
                        <div className="single-input">
                          <input 
                            type="text" 
                            id='equipamento' 
                            name='equipamento' 
                            placeholder='Selecione o Equipamento' 
                            className='w-full p-2 border border-gray-300 rounded-md' 
                            autoComplete='identificador' 
                            value={nomeEquipamento} 
                            onChange={(e) => setEquipamentoSelected(e.target.value)}
                            readOnly={readOnly}
                          />
                        </div>
                      )}
                    </div>
                    <div>
                      <div className="input-group md:mb-3">
                        <label>Horas:</label>
                        <div className="single-input">
                          <input 
                            name='horas' 
                            placeholder={'Digite a quantidade de Horas'}
                            className='w-full p-2 border border-gray-300 rounded-md' 
                            value={horas} 
                            onChange={(e) => setHoras(e.target.value)}
                            readOnly={readOnly}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  {(funcao === 'Inclusão' || funcao === 'Alteração') ? ( 
                    <></>
                  ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="input-group md:mb-3">
                        <label>Data Inicial</label>
                        <input 
                          type="text" 
                          id='datainclusao' 
                          name='inclusao' 
                          placeholder={'Data Inicial'}
                          className='w-full p-2 border border-gray-300 rounded-md' 
                          autoComplete='Inclusão' 
                          value={dataInicial} 
                          onChange={(e) => setDataInicial(e.target.value)}
                          readOnly={readOnly}
                        />
                      </div>
                      <div className="input-group md:mb-3">
                        <label>Data Final</label>
                          <input 
                            type="text" 
                            id='datainclusao' 
                            name='inclusao' 
                            placeholder={'Data Final'}
                            className='w-full p-2 border border-gray-300 rounded-md' 
                            autoComplete='Inclusão' 
                            value={dataFinal} 
                            onChange={(e) => setDataFinal(e.target.value)}
                            readOnly={readOnly}
                          />
                        </div>
                    </div>
                  )}
                </div>
                <div>
                  <div className="input-group md:mb-3">
                    <label>Observação</label>
                    <div className="single-input">
                      <input 
                        type="text" 
                        id='observacao' 
                        name='observacao' 
                        placeholder={'Digite a observação'}
                        className='w-full p-2 border border-gray-300 rounded-md' 
                        autoComplete='observacao' 
                        value={observacao} 
                        onChange={(e) => setObservacao(e.target.value)}
                        readOnly={readOnly}
                      />
                    </div> 
                  </div>
                </div>
                <div>
                  <div>
                    <div className="input-group md:mb-3">
                      <label>Desvio</label>

                      {(funcao === 'Inclusão' || funcao === 'Alteração') ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div className="single-input">
                            <span>
                              <select className="combo-select" value={desvioSelected} onChange={e => handleChangeDesvio(e.target.value)} >
                                {(funcao === 'Inclusão') ? (
                                  <option key='0' value=''>Selecione um desvio</option>
                                ):(
                                  <option key={desvioId} value={desvioSelected}>{descricaoDesvio}</option>
                                )}
                                {desvios.map((item, index) => {
                                  return(
                                    <option key={item.cod_desvio} value={index}>
                                      {item.des_desvio}
                                    </option>
                                  )
                                })}
                              </select>
                              <button type='button'onClick={() => limpaDesvio()}>
                                <FaCircleXmark color='blue' size={16} />
                              </button>
                            </span>
                          </div>
                        </div>
                      ):(
                        <div>
                          <div className="input-group mb-3">
                            <input 
                              type="text" 
                              id='desvio' 
                              name='desvio' 
                              placeholder='' 
                              className='w-full p-2 border border-gray-300 rounded-md' 
                              autoComplete='desvio' 
                              value={descricaoDesvio} 
                              onChange={(e) => setDesvioId(e.target.value)}
                              readOnly={readOnly}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className="grid grid-rows-2">
                  <div className="flex items-center gap-2">
                    <label className="text-sm font-medium text-gray-700">Foto Desvio {idtFotoDesvio}</label>
                    {(funcao === 'Inclusão' || funcao === 'Alteração') && (
                        <button type='button' className="text-blue-600 text-lg md-4" onClick={() => setMostrarModalImagem(true)}>
                          <TbPhotoSearch size={16} /> 
                        </button>
                    )}

                    {(funcao === 'Alteração' && (fotoDesvio || preview)) && (
                        <button type='button'onClick={() => limpaArquivo()}>
                          <FaCircleXmark color='blue' size={16} />
                        </button>
                    )}
                  </div>

                  <div>
                    {(funcao === 'Inclusão' && fotoDesvio) && (
                      <img src={preview} alt="Inicial" style={{ maxWidth: '10%', marginTop: 10, marginBottom: 10 }} />
                    )}

                    {(funcao !== 'Inclusão' && preview) && (
                      <img src={preview} alt="Inicial" style={{ maxWidth: '10%', marginTop: 10, marginBottom: 10 }} />
                    )}

                    <ModalImagem
                      isOpen={mostrarModalImagem}
                      onClose={() => setMostrarModalImagem(false)}
                      onSelecionar={(file) => selecionarImagem(file)}
                      titulo='Desvio'
                    />
                  </div>

                  <div className="row grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-2">
                    <div className="input-group mb-3">
                      <label className="block text-sm font-medium mb-1">Foi Basculado?</label>
                      <div className='flex items-center gap-2'>
                        <div className="single-input flex items-center">
                          <input 
                            type="radio" 
                            id='basculado' 
                            name='basculado' 
                            value='S' 
                            onChange={(e) => setBasculado(e.target.value)} 
                            checked={basculado === 'S'}
                            disabled={readOnly}
                          /> 
                          <label className='mb-0'>Sim</label>
                        </div>
                        <div className="single-input flex items-center">
                          <input 
                            type="radio" 
                            id='naobasculado' 
                            name='naobasculado' 
                            value='N' 
                            onChange={(e) => setBasculado(e.target.value)} 
                            checked={basculado === 'N'}
                            disabled={readOnly}
                          /> 
                          <label>Não</label>
                        </div>
                      </div>
                    </div>
                    <div className="input-group mb-3">
                      <label className="block text-sm font-medium mb-1">Situação</label>
                      <div className='flex items-center gap-2'>
                        <div className="single-input flex items-center">
                          <input 
                            type="radio" 
                            id='ativo' 
                            name='ativar' 
                            value='A' 
                            onChange={(e) => setSituacao(e.target.value)} 
                            checked={situacao === 'A'}
                            disabled={readOnly}
                          /> 
                          <label className='mb-0'>Em Aberto</label>
                        </div>
                        <div className="single-input flex items-center">
                          <input 
                            type="radio" 
                            id='finalizado' 
                            name='ativar' 
                            value='F' 
                            onChange={(e) => setSituacao(e.target.value)} 
                            checked={situacao === 'F'}
                            disabled={readOnly}
                          /> 
                          <label>Finalizada</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Análises */}
              {(funcao === 'Consulta') ? (
                <div className='border-t border-secondary grid-cols-2'>
                  <div className="flex items-center">
                    <h3 className="text-xl font-semibold text-gray-700">Análise por Compartimento</h3>
                    <button
                      onClick={() => incluirAnalise()}
                      className="bg-green-600 text-green px-4 py-2 rounded hover:bg-green-700 transition"
                    >
                      <CgAdd size={20} color="green" />
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {analises.map((item, index) => (
                      <section>
                        <AnaliseCard key={index} data={item} editarAnalise={editarAnalise} excluirAnalise={excluirAnalise}  />
                      </section>
                    ))}
                  </div>
                </div>
              ) : (
                <></>
              )}

              <Footer modulo='Ordem' funcao={funcao} executa={executaAcao} sair={handleSair} imprimir={imprimirOrdem} />

              {/* Documento de Aprovação */}
              {(funcao === 'Consulta') ? (
                <div className='border-t border-secondary grid-cols-2'>
                  <div className="flex items-center">
                    <h3 className="text-xl font-semibold text-gray-700">Documento de Aprovação</h3>
                    {(idtDocAprovacao === '') ? (
                      <button
                        onClick={() => incluirAprovacao('Inclusão')}
                        className="bg-green-600 text-green px-4 py-2 rounded hover:bg-green-700 transition"
                      >
                        <CgAdd size={20} color="green" />
                      </button>
                    ):(
                      <div>
          <button
            onClick={() => incluirAprovacao('Alteração')}
            className="bg-green-600 text-green px-4 py-2 rounded hover:bg-green-700 transition"
          >
            <FiEdit2 size={20} color="green" />
          </button>
          <button
            onClick={() => incluirAprovacao('Exclusão')}
            className="bg-green-600 text-green px-4 py-2 rounded hover:bg-green-700 transition"
          >
            <FiTrash2 size={20} color="green" />
          </button>
                      </div>
                    )}
                  </div>

                  {(idtDocAprovacao !== '') ? (
                    <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                      <section>
                        <DocumentoCard 
                          documento={{clienteId: clienteId, ordemId: ordemId, idtDocAprovacao: idtDocAprovacao}} 
                          editarDocumento={() => incluirAprovacao('Alteração')} 
                          excluirDocumento={() => incluirAprovacao('Exclusão')}  
                        />
                      </section>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}

            </div>
          </section>
        </section>
      </main>
      <Rodape versao={Globais.versao}/>
    </div>
  );
}